module.exports = __webpack_public_path__ + "img/DE01578.e3adb80f.png";